var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.667 4H7.66699C4.66699 4 2.66699 5.5 2.66699 9V16C2.66699 19.5 4.66699 21 7.66699 21H17.667C20.667 21 22.667 19.5 22.667 16V9C22.667 5.5 20.667 4 17.667 4ZM18.137 10.09L15.007 12.59C14.347 13.12 13.507 13.38 12.667 13.38C11.827 13.38 10.977 13.12 10.327 12.59L7.19699 10.09C6.87699 9.83 6.82699 9.35 7.07699 9.03C7.33699 8.71 7.80699 8.65 8.12699 8.91L11.257 11.41C12.017 12.02 13.307 12.02 14.067 11.41L17.197 8.91C17.517 8.65 17.997 8.7 18.247 9.03C18.507 9.35 18.457 9.83 18.137 10.09Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5f587df70dc5a4f8cc03fe63a8ea87dd.svg";
export { ForwardRef as ReactComponent };